import { Pressable, Text } from 'react-native'
import { useTranslation } from 'react-i18next'
import { ArrowLeft } from 'lucide-react-native'
import { colors } from '@chillout/core'

interface BackToSignInLinkProps {
  onPress: () => void
  className?: string
}

export function BackToSignInLink({ onPress, className }: BackToSignInLinkProps) {
  const { t } = useTranslation()

  return (
    <Pressable
      onPress={onPress}
      accessibilityRole="link"
      accessibilityLabel={t('adminAuth.backToSignIn')}
      className={`flex-row items-center gap-2 self-center ${className ?? ''}`}
    >
      <ArrowLeft size={18} color={colors.accent.DEFAULT} strokeWidth={2} />
      <Text className="text-base font-normal text-accent">
        {t('adminAuth.backToSignIn')}
      </Text>
    </Pressable>
  )
}
